import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core'
import { AbstractControl, UntypedFormControl, UntypedFormGroup } from "@angular/forms"
import { MomentDateAdapter } from "@angular/material-moment-adapter"
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core"
import { MatTableDataSource } from "@angular/material/table"
import { ActivatedRoute, Router } from "@angular/router"
import * as moment from "moment"
import { filter, first, Subscription } from 'rxjs'
import { Client } from '../../shared/client/client'
import { ClientService } from '../../shared/client/client.service'
import { CUSTOM_DATE_FORMAT } from "../../shared/datepicker/datepicker-format"
import { SideBarService } from "../../shared/sidebar/side-bar.service"
import { Delivery } from '../shared/delivery'
import { DeliveryListService } from "../shared/delivery-list/delivery-list.service"

@Component({
  selector: 'app-delivery-list',
  templateUrl: './delivery-list.component.html',
  styleUrls: ['./delivery-list.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE], },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMAT },
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' }
  ],
})

export class DeliveryListComponent implements OnInit, OnDestroy {
  @HostBinding('class.clamp') clamp = true

  dataSource: MatTableDataSource<Delivery> = new MatTableDataSource<Delivery>()
  // Colonnes
  columns = [
    { id: 'CONS_COD', libelle: 'Code article' },
    { id: 'ART_DES', libelle: 'Désignation article' },
    { id: 'QTE', libelle: 'Quantité article' },
  ]
  displayedColumns: Array<string> = ['CONS_COD', 'ART_DES', 'QTE', 'actions']
  dateList: Array<moment.Moment> = []
  dateSelected: moment.Moment
  sub: Subscription = new Subscription()
  subClient: Subscription
  dateLoading: boolean = false
  load: boolean = true
  minDate = moment().subtract(2, 'months')
  currentClient: Client
  hasLingePlat: boolean = false

  group: UntypedFormGroup
  /**
   *
   * @param {DeliveryListService} deliveryListService
   * @param {Router} router
   * @param {SideBarService} sideBar
   * @param route
   */
  constructor(
    private deliveryListService: DeliveryListService,
    private router: Router,
    private sideBar: SideBarService,
    private route: ActivatedRoute,
    protected clientService: ClientService
  ) {
    moment.locale('fr')
  }

  ngOnInit() {
    this.group = new UntypedFormGroup({
      'inputdate': new UntypedFormControl({ value: '', disabled: false }, [
      ])
    })

    this.subClient = this.clientService.getCurrentClient().subscribe(client => {
      this.currentClient = client
      this.dataSource.data = Array<any>()
      this.loadDate(this.currentClient)
    })

    this.group.controls['inputdate'].disable()
    this.inputdate.valueChanges.subscribe(chosenDate => this.getDeliveryList())
  }

  get inputdate(): AbstractControl {
    return this.group.get('inputdate')
  }

  ngOnDestroy() {
    this.sub.unsubscribe()
    if (this.subClient) {
      this.subClient.unsubscribe()
    }
  }

  private loadDate(client) {
    this.sub.unsubscribe()
    this.dateLoading = true
    this.sub = this.deliveryListService.getDates(client).subscribe(data => {
      this.dateList = data
      this.dateLoading = false
      this.load = false
      this.inputdate.patchValue(this.dateList[0])
    })
  }

  /**
   *
   * @param $event
   */
  getDeliveryList() {
    if (this.inputdate.value != null && this.inputdate.value.isValid()) {
      this.dateSelected = this.inputdate.value.format('YYYY-MM-DD')
      this.inputdate.disable({ emitEvent: false })
      this.dataSource.data = Array<any>()
      if (this.sub !== null) {
        this.sub.unsubscribe()
      }
      this.sub = this.deliveryListService.getDeliveries(this.currentClient, this.inputdate.value).subscribe(data => {
        this.load = true
        if (data) {
          this.dataSource.data = data
          this.hasLingePlat = data && data.some((a) => a.ART_FAM == 1)
        }
        this.load = false
        this.inputdate.enable({ emitEvent: false })
      })
    }
  }

  // Filtre des dates de livraisons
  /**
   *
   * @param {Moment} d
   * @returns {boolean}
   */
  myFilter = (d: moment.Moment): boolean => {
    return this.dateList.some(val => {
      return val.isSame(d, 'day')
    })
  }

  isDisplay(row: Delivery): boolean {
    const indice: number = Number(row.CONS_COD.charAt(0))
    return row.ART_FAM != 1 && (indice > 2 || indice < 9)
  }

  /**
   *
   * @param row
   * @returns {Promise<void>}
   */
  deliveryListCab(row: Delivery) {
    window.scrollTo(0, 0)
    if (this.isDisplay(row)) {
      let outlets = {}
      outlets['sidebar'] = [this.dateSelected, row.CONS_COD]
      this.router.navigate([{ outlets }], {
        relativeTo: this.route.parent,
        skipLocationChange: true,
      }).then(() => this.sideBar.toggle())
    }
  }

  export() {
    this.sub = this.deliveryListService.exportBordereauLivraison(this.currentClient, this.inputdate.value).subscribe()
  }
}
